import './styles.css'
import { initChrome } from './chrome.js'

// Deliberately a .js file with no JSX in it. Any JSX here would make the react
// plugin add an `import 'react/jsx-runtime'` at module scope, and React's CJS build
// has side effects — so Rollup cannot drop it even though the only JSX sits in a
// branch that is dead in production. That put all of React (~10KB) on the critical
// path. React.createElement via a dynamic import keeps the entry chunk at ~1KB.
async function start() {
  // In production the markup is already there, prerendered at build time, and React
  // never touches the page shell. The dev server has no prerender step, so it renders
  // the same component tree on the client — which is what makes HMR work while you
  // edit copy and components.
  if (import.meta.env.DEV) {
    const [React, { default: App }, { createRoot }, { flushSync }, { routeFor }] =
      await Promise.all([
        import('react'),
        import('./App.jsx'),
        import('react-dom/client'),
        import('react-dom'),
        import('./routes.js'),
      ])
    const route = routeFor(location.pathname)
    document.documentElement.lang = route.t.locale
    document.title = (route.page === 'home' ? route.t.meta.home : route.t.meta.privacy).title
    // flushSync, because React 18 commits `render()` asynchronously and initChrome()
    // below queries the DOM for [data-reveal] and [data-island]. Without it the dev
    // server wires up nothing — which is invisible in prod, where the markup is
    // prerendered and already present.
    flushSync(() => {
      createRoot(document.getElementById('root')).render(
        React.createElement(App, { route }),
      )
    })
  }
  initChrome()
}

start()
